import type { FC } from "react";
import { useMemo } from "react";
import classes from "./SwiperAmba.module.scss";
import "./swiper_a.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { v4 as uuidv4 } from "uuid";
import clsx from "clsx";

import "swiper/css";
import "swiper/css/pagination";

import { EffectCoverflow, Pagination } from "swiper";

export interface SwiperCompProps {
	className?: string;
}

export interface imagesType {
	name: string;
	stage: string;
	img: string;
}

export interface SwiperCompComponent extends FC<SwiperCompProps> {}

export const SwiperAmba: SwiperCompComponent = ({ className }) => {
	const images: imagesType[] = [
		{
			name: "Jenny Wilson",
			img: "images/a-1.png",
			stage: " Co - Founder, CEO",
		},
		{
			name: "Jenny Wilson",
			img: "images/a-2.png",
			stage: " Co - Founder, CEO",
		},
		{
			name: "Jenny Wilson",
			img: "images/a-3.png",
			stage: " Co - Founder, CEO",
		},
		{
			name: "Jenny Wilson",
			img: "images/a-4.png",
			stage: " Co - Founder, CEO",
		},
		{
			name: "Jenny Wilson",
			img: "images/a-5.png",
			stage: " Co - Founder, CEO",
		},
	];

	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	const duplicatedImages = [...images];

	return (
		<div className={wrapperClassName}>
			<Swiper
				centeredSlides={true}
				slidesPerView={1}
				loop={true}
				effect={"slide"}
				breakpoints={{
					825: {
						spaceBetween: -500,
						slidesPerView: 2,
					},
				}}
				pagination={{
					clickable: true,
				}}
				modules={[EffectCoverflow, Pagination]}
				className={classes.mySwiper}
			>
				{duplicatedImages.map(({ img, name, stage }) => (
					<SwiperSlide key={uuidv4()}>
						<div className="a-swiper">
							<div>
								<img className={classes.image} src={img} alt={name} />
								<div className={classes.info}>
									<h5 className={classes.name}>{name}</h5>
									<span className={classes.stage}>{stage}</span>
								</div>
							</div>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};
